import TextInput from "../../../components/files/TextInput";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import http from "../../../http";
import { setShowLoading } from "../../../store/sysSlice";
import { useDispatch, useSelector } from "react-redux";
import { apiUrl } from "../../../config/settings";
import { endpointNameItems } from "../const";
import { Stack } from "@mui/material";
import useDataManager from "../../../hooks/useDataManager";
import CustomDialog from "components/CustomDialog";
import MultipleSelectInput from "components/files/MultipleSelectInput";
import { DEPARTMENT_MANAGER, ROLES_ID } from "config/roles";
import CheckRole from "components/CheckRole";

const Details = ({ item, setItem, setList, list, checkListId, employees, userRole }) => {
  const { addItem, editItem } = useDataManager();
  const dispatch = useDispatch();
  const { reset, handleSubmit, control, formState: { errors } } = useForm();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (item && item !== "new") {
      reset(item);
      setData(item);
    }
  }, [item]);

  const onClose = () => {
    setItem(false);
  };

  const onSubmit = (values) => {
    dispatch(setShowLoading(true));

    let data = {
      name: values.name,
      desc: values.desc,
      employees: values.employees,
      checkList: checkListId,
    };

    if (item?.id !== "new") {
      http
        .patch(`${apiUrl}/${endpointNameItems}/${item?.id}`, data)
        .then((res) => {
          dispatch(setShowLoading(false));
          data.id = item?.id;
          const newList = editItem({ ...item, ...data }, list);
          setList(newList);
          onClose();
        })
        .catch((error) => {
          dispatch(setShowLoading(false));
        });
    } else {
      http
        .post(`${apiUrl}/${endpointNameItems}`, data)
        .then((res) => {
          dispatch(setShowLoading(false));
          data.id = res?.data?.itemId;
          const newList = addItem(data, list);
          setList(newList);
          onClose();
        })
        .catch((error) => {
          dispatch(setShowLoading(false));
        });
    }
  };

  if (!data && item?.id !== "new") return;

  return (
    <CustomDialog
      open={item ? true : false}
      onClose={onClose}
      title='DETAILS'
      closeBtn='CLOSE'
      actionBtn={{ title: 'SAVE', onClick: () => handleSubmit(onSubmit)() }}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack width="100%" minWidth={{ xs: "auto", sm: 350 }} gap={2}>
          <TextInput
            name="name"
            errors={errors}
            required
            title="NAME"
            width="100%"
            disabled={userRole === ROLES_ID.EMPLOYEE}
            control={control}
          />

          <TextInput
            rows={4}
            errors={errors}
            name="desc"
            width="100%"
            title="DESC"
            disabled={userRole === ROLES_ID.EMPLOYEE}
            control={control}
          />

          <CheckRole role={DEPARTMENT_MANAGER}>
            <MultipleSelectInput
              name="employees"
              title="EMPLOYEES"
              errors={errors}
              control={control}
              options={employees?.map((emp) => { return { name: `${emp.fn} ${emp.ln}`, id: emp.id } })}
            />
          </CheckRole>
        </Stack>
      </form>
    </CustomDialog>
  );
};
export default Details;
